$(() => {

  $('.reporting-elearning').select2({
    matcher: function (params, data) {
      const term = params.term?.toLowerCase() || '';
      if (!params.term) {
        return data; 
      }

      const text = data.text?.toLowerCase() || '';
      const code = `C-${data.id}`?.toLowerCase() || '';
      if (text.includes(term) || code === term) {
        return data;
      }

      return null;
    }
  });
});
